import React from "react";
import { mediaLinks } from "../helper/Helper";

function Community() {
  return (
    <>
      <div
        className="  px-4 -mb-40 xl:-mb-80 relative z-20"
        data-aos="fade-down"
        data-aos-duration="1500"
      >
        <div
          id="Community"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8 my-12 xl:my-20 py-16 xl:py-20 2xl:py-28 text-center relative  community-bg "
        >
          <h2 className="text-white text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2">
            Join Our Community
          </h2>
          <p className="text-white text-base lg:text-lg  leading-[180%] py-4 md:py-6 xl:py-8  capitalize ">
            the strongest man on solana is waiting for you
          </p>
          <div className="flex items-center justify-center gap-3 sm:gap-6 lg:pb-8">
            <a
              href="https://dexscreener.com/solana/7suklvbqlkam7iyot6omjwqgtehwuy6wp58b5ofphg88"
              className="bg-white text-[#0279E1] py-2.5 sm:py-3 xl:py-5 px-5 sm:px-6 xl:px-10 border border-black rounded-xl 
               shadow-[0px_6px_0px_0px_#000]   text-lg sm:text-xl xl:text-2xl 2xl:text-[32px] text-aircruiser   transition-all duration-300 ease-in-out hover:shadow-[0px_6px_20px_0px_#000]
              "
            >
              Buy $JOSH
            </a>{" "}
            {mediaLinks.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="p-2.5 sm:p-3 xl:p-5     bg-white rounded-xl  flex flex-col justify-center items-center shadow-[1.38px_4.14px_0px_0px_#000] transition-all duration-300 ease-in-out group   hover:shadow-[0px_3px_10px_0px_#000]"
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Community;
